var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute position-top-0 position-bottom-0 drag-handle",class:_vm.className,style:(_vm.cursorStyle),on:{"mousedown":_vm.startDrag,"dblclick":_vm.resetSize}},[_vm._t("thumbnail")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }